import { render, staticRenderFns } from "./LessorItemEdit.vue?vue&type=template&id=1118d190&"
import script from "./LessorItemEdit.vue?vue&type=script&lang=js&"
export * from "./LessorItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports